// src/components/chat/LegalReferencesDisplay.js
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const LegalReferencesDisplay = ({ data }) => {
  if (!data) return null;

  return (
    <Container>
      {data.topic && (
        <Section>
          <Heading>Thema:</Heading>
          <p>{data.topic}</p>
        </Section>
      )}
      {data.relevante_gesetzesstellen &&
        data.relevante_gesetzesstellen.length > 0 && (
          <Section>
            <Heading>Relevante Gesetzesstellen:</Heading>
            <List>
              {data.relevante_gesetzesstellen.map((item, index) => (
                <ListItem key={`gesetz-${index}`}>{item}</ListItem>
              ))}
            </List>
          </Section>
        )}
      {data.urteil_suche && data.urteil_suche.length > 0 && (
        <Section>
          <Heading>Vorschläge für Urteilssuche:</Heading>
          <List>
            {data.urteil_suche.map((item, index) => (
              <ListItem key={`suche-${index}`}>{item}</ListItem>
            ))}
          </List>
        </Section>
      )}
      {data.law_list && data.law_list.length > 0 && (
        <Section>
          <Heading>Genannte Gesetze:</Heading>
          <List>
            {data.law_list.map((item, index) => (
              <ListItem key={`law-${index}`}>{item}</ListItem>
            ))}
          </List>
        </Section>
      )}
    </Container>
  );
};

const Container = styled.div`
  background-color: ${theme.colors.backgroundLight || '#f8f9fa'};
  border: 1px solid ${theme.colors.border || '#dee2e6'};
  border-radius: ${theme.borderRadius.md || '8px'};
  padding: 1rem;
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: ${theme.colors.text};
`;

const Section = styled.div`
  margin-bottom: 0.75rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Heading = styled.h4`
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0.4rem;
  color: ${theme.colors.primary};
  font-size: 0.95rem;
`;

const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const ListItem = styled.li`
  background-color: ${theme.colors.secondary}15;
  padding: 0.25rem 0.6rem;
  border-radius: ${theme.borderRadius.sm || '4px'};
  border: 1px solid ${theme.colors.secondary}30;
  font-family: monospace;
  font-size: 0.85rem;
  white-space: nowrap;
`;

export default LegalReferencesDisplay;
